import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4450c51c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "my_dialog"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "670px"
  }
}, [/*#__PURE__*/_createElementVNode("iframe", {
  id: "iframe",
  width: "100%",
  height: "100%",
  frameborder: "0",
  scrolling: "auto",
  src: "https://affim.baidu.com/cps/chat?siteId=32716&userId=865345&siteToken=3e80fb1c17b97791d5bcdd3e91c617a7"
}, "\n                ")], -1));
import { ref } from 'vue';
export default {
  __name: 'index',
  setup(__props, {
    expose
  }) {
    const visible = ref(false);
    const openDialog = function () {
      visible.value = true;
    };
    const hideDialog = function () {
      visible.value = false;
    };
    expose({
      openDialog,
      hideDialog
    });
    return (_ctx, _cache) => {
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: visible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => visible.value = $event),
        "show-close": false,
        width: "840px",
        height: "200px",
        "align-center": "",
        "destroy-on-close": ""
      }, {
        default: _withCtx(() => [_hoisted_2]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};